
<template>
    <div>
    <el-dialog :title="infodetail.name+'员工详情'" @close="close" width="630px" :visible.sync="dialogFormVisible">
        <el-row class="info_box">
            <el-col :span="8" style="text-align: center;">
                <img :src="avatar" style="width: 80px;border-radius: 50%;">
            </el-col>
            <el-col :span="16" style="text-align: left;">
                <el-col :span="24" style="">所在企业 : {{infodetail.companyName}}</el-col>
                <el-col :span="12" style="">所属部门 : {{infodetail.deptName}}</el-col>
                <el-col :span="12" style="">员工姓名 : {{infodetail.name}}</el-col>
                <el-col :span="12" style="">手机号码 : {{infodetail.phone}}</el-col>
                <el-col :span="12" style="">企业审核状态 : {{company(infodetail.companyAuthStatus)}}</el-col>
                <el-col :span="12" style="">用户状态 : {{iscompanystate(infodetail.status)}}</el-col>
                <el-col :span="12" style="">注册时间 : {{infodetail.createtime}}</el-col>
            </el-col>

        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button v-if="status!=2" class="filter-item filter-item1" size="mini" @click="handleStop" type="primary" icon="el-icon-circle-close-outline" >冻结</el-button>
            <el-button v-if="status!=1" class="filter-item filter-item1" size="mini" @click="handleStart"  type="primary" icon="el-icon-circle-check-outline">解冻</el-button>
            <el-button class="filter-item filter-item1" size="mini" @click="deletecompany"  type="primary" icon="el-icon-circle-check-outline">删除</el-button>
        </div>
    </el-dialog>
     <personnelcald ref="childcald" @refresh="refresh"></personnelcald>
    </div>
</template>
<script>
    import {stop,getpersonnel,deletepersonnel} from '@/api/admin/workerUser'
    import {getImgLink} from '@/config/env'
    import {mapGetters} from 'vuex'
    import {dataday} from '@/util/dateT'
    import {objKeySort } from '@/util/ajaxsign'
     import personnelcald from './personnelcald.vue'

    export default {
        components: {personnelcald},
        data() {
            return {
                userId : '',
                dialogFormVisible : false,
                dictionarylist : [],
                avatar : '',
                deptName : '',
                infodetail:{},
                name : '',
                phone : '',
                status : '',
                companyAuthStatus : '',
                createtime :''
            }
        },
        created() {},
        mounted() {},
        methods: {
            //刷新列表操作
            refresh(){
                this.getCompanyInfo();
                this.$emit('refresh');
            },
            //设置展示
            setsataus(userId,infodetail){
                this.dialogFormVisible = true;
                this.userId = userId;
                this.infodetail = infodetail;
                this.getCompanyInfo(infodetail);
                console.log(infodetail);
            },

            //项目详情数据请求
            getCompanyInfo(){
                getpersonnel(objKeySort({userId:this.userId})).then(response => {
                    this.avatar = response.data.data.avatar?getImgLink(response.data.data.avatar):response.data.data.headimgurl?response.data.data.headimgurl:'/img/default-avatar.png';
                    this.deptName = response.data.data.deptName?response.data.data.deptName:'未设置';
                    this.name =  response.data.data.name;
                    this.phone =  response.data.data.phone;
                    this.status = response.data.data.status;
                    this.companyAuthStatus = response.data.data.companyAuthStatus;
                    this.createtime = dataday(response.data.data.createtime);
                })
            },

            //默认时间
            settime(data){
                return dateOnce(data)
            },

            //冻结
            handleStop() {
                this.$refs.childcald.setsataus(this.userId,"冻结原因");
            },

            //删除员工
            deletecompany(){
                this.$confirm('此操作将永久删除'+this.name+'企业, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        deletepersonnel(objKeySort({userId : this.userId})).then(response => {
                            this.refresh()
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.dialogFormVisible = false;
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            handleStart(){
                this.$refs.childcald.setsataus(this.userId,"解冻原因");
            },
            //取消回调
            close(){
                console.log("取消")
            },

            iscompanystate(data){
                console.log(data);
                if(data ==1){
                    return '正常'
                }else if(data ==2){
                    return '冻结'
                }else if(data ==3){
                    return '删除'
                }
            },
            company(data){
                if(data == 1){
                     return  '审核通过'
                }else if(data == -1){
                     return  '拒绝加入'
                }else{
                     return  '申请加入'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.container{
    min-width:800px;
    max-width:900px;
}
.form_layout_items{
    display:flex
}
.select_option{
    position: absolute;
    z-index: 22;
    width: 150px !important;
    right: 0;
    top: 0;
}
.el-table /deep/ .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }
  .form_layout_item{
      width:50%;
      border:1px solid #fff;
      height:80px;
  }
</style>
